import React, { useEffect } from 'react';
import { useSessionStorage, useFeatureFlags } from 'hooks';

export default function GradeBookRoot() {
  const isIframedInSeismic = useSessionStorage('iframedInSeismic');
  const hasUnificationFeatureFlag = useFeatureFlags(
    'readiness-enable-unification',
  );
  useEffect(() => {
    if (isIframedInSeismic && hasUnificationFeatureFlag) {
      const psuedoRoot = document.querySelector(':root');
      psuedoRoot.style.setProperty('--llui-navbar-height', '102px');
    }
  }, [isIframedInSeismic, hasUnificationFeatureFlag]);

  return <div />;
}
